import { NavLink, Link } from 'react-router-dom';
import { Phone, MessageCircle } from 'lucide-react';
import { TEL_HREF, TEL_DISPLAY, waLink } from '../lib/contact';

const WA_HELLO = waLink('Hola Bar Cabrero. Una pregunta:');

/**
 * Mobile slide-down menu — mirrors the desktop dropdown structure:
 *   1. Quiz banner (hero) → /gildas#quiz
 *   2. Carta items with WebP thumbnails
 *   3. Secondary plain links (Historia, Galería, Visítanos)
 *   4. Sticky CTA "Pedir bandeja" + tel + WhatsApp icons
 */
export default function MobileMenu({ open, entries, onClose }) {
  // Pull the Carta group + the secondary links from props
  const cartaGroup = entries.find((e) => e.items);
  const secondary = entries.filter((e) => e.to);

  return (
    <div className={`mobile-menu ${open ? 'open' : ''}`} data-testid="mobile-menu">
      <div className="mm-scroll">
        {/* QUIZ BANNER */}
        <NavLink
          to="/gildas#quiz"
          onClick={onClose}
          className="mm-quiz"
          data-testid="mm-quiz"
        >
          <span className="mm-quiz-eyebrow">Descubre tu gilda</span>
          <span className="mm-quiz-title">¿Cuál es <em>tu Gilda?</em></span>
          <span className="mm-quiz-meta">12 variedades · 3 preguntas · 30 segundos</span>
          <span className="mm-quiz-arrow" aria-hidden="true">→</span>
        </NavLink>

        {/* CARTA ITEMS WITH THUMBS */}
        {cartaGroup && (
          <div className="mm-section">
            <span className="mm-section-l">{cartaGroup.label}</span>
            <ul className="mm-list">
              {cartaGroup.items.map((it) => (
                <li key={it.to}>
                  <NavLink
                    to={it.to}
                    end
                    onClick={onClose}
                    className={({ isActive }) => `mm-item ${isActive ? 'active' : ''}`}
                    data-testid={`mm-${it.to.replace('/', '')}`}
                  >
                    {it.img && (
                      <span className="mm-item-img" aria-hidden="true">
                        <img src={it.img} alt="" loading="lazy" />
                      </span>
                    )}
                    <span className="mm-item-text">
                      <span className="mm-item-label">{it.label}</span>
                      {it.hint && <span className="mm-item-hint">{it.hint}</span>}
                    </span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* SECONDARY LINKS */}
        {secondary.length > 0 && (
          <ul className="mm-secondary">
            {secondary.map((e) => (
              <li key={e.to}>
                {e.download ? (
                  <a
                    href={e.to}
                    download={e.download}
                    onClick={onClose}
                    data-testid={`mm-${e.label.toLowerCase()}`}
                  >
                    {e.label}
                  </a>
                ) : (
                  <NavLink
                    to={e.to}
                    end={e.to === '/'}
                    onClick={onClose}
                    className={({ isActive }) => (isActive ? 'active' : '')}
                    data-testid={`mm-${e.to.replace('/', '') || 'home'}`}
                  >
                    {e.label}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* PINNED FOOTER — CTA + contacts */}
      <div className="mm-foot">
        <Link
          to="/pedido"
          onClick={onClose}
          className="mm-cta"
          data-testid="mm-cta"
        >
          Pedir bandeja
        </Link>
        <div className="mm-contacts">
          <a href={TEL_HREF} className="mm-contact" data-testid="mm-tel" aria-label={`Llamar ${TEL_DISPLAY}`}>
            <Phone size={15} strokeWidth={2.2} />
            <span>{TEL_DISPLAY}</span>
          </a>
          <a
            href={WA_HELLO}
            target="_blank"
            rel="noopener noreferrer"
            className="mm-contact mm-contact-wa"
            data-testid="mm-whatsapp"
            aria-label="Escribir por WhatsApp"
          >
            <MessageCircle size={15} strokeWidth={2.2} />
            <span>WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
  );
}
